import {
  createPlugin,
  createRoutableExtension,
  createComponentExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const awsCostExplorerPlugin = createPlugin({
  id: 'aws-cost-explorer',
  routes: {
    root: rootRouteRef,
  },
});

/** Full-page cost explorer dashboard (for /cost-explorer route). */
export const AwsCostExplorerPage = awsCostExplorerPlugin.provide(
  createRoutableExtension({
    name: 'AwsCostExplorerPage',
    component: () =>
      import('./components/CostDashboard').then(m => m.CostDashboard),
    mountPoint: rootRouteRef,
  }),
);

/** Entity tab content — shows costs filtered by entity tags. */
export const EntityCostExplorerContent = awsCostExplorerPlugin.provide(
  createComponentExtension({
    name: 'EntityCostExplorerContent',
    component: {
      lazy: () =>
        import('./components/EntityCostContent').then(
          m => m.EntityCostContent,
        ),
    },
  }),
);
